<template>
  <div>
    <validation-provider
      #default="{ errors }"
      name="country"
      :rules="requiredField ? 'required' : ''"
    >
      <b-form-group
        label="País"
        label-for="country"
      >
        <v-select
          id="country"
          v-model="country"
          :class="errors.length > 0 ? 'error-select' : ''"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :filter="fuseSearch"
          label="code"
          :options="dataOptions"
          :placeholder="'País'"
          :disabled="readonly"
          :clearable="!readonly"
        >
          <template #option="{ name }">
            <span>{{ name }} </span>
          </template>

          <template #selected-option="{ name }">
            <span>{{ name }} </span>
          </template>

          <template #no-options>
            Não há opções de países.
          </template>
        </v-select>
        <small class="text-danger">{{ errors[0] }}</small>
      </b-form-group>
    </validation-provider>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import {
  BFormGroup,
} from 'bootstrap-vue'
import {
  ValidationProvider,
} from 'vee-validate'
import { required } from '@validations'
import { useToast } from 'vue-toastification/composition'
import Fuse from 'fuse.js'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import syslic from '@/syslic'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  model: {
    prop: 'countryValue',
    event: 'countryChange',
  },
  props: {
    countryValue: {
      type: [Object, String],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: true,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    const dataOptions = []

    return {
      dataOptions,
      required,
    }
  },
  computed: {
    country: {
      get() {
        return this.countryValue
      },
      set(value) {
        this.$emit('countryChange', value)
      },
    },
  },
  created() {
    this.onCreate()
  },
  methods: {
    onCreate() {
      syslic
        .address
        .fetchCountries()
        .then(response => {
          this.dataOptions = response.results
          this.$emit('ready', true)
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao ler os dados.',
              text: 'Não foi possível ler os dados do servidor, por favor entre em contato com o administrador do sistema.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
          this.$emit('ready', true)
        })
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['code', 'name'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
  },
  setup() {
    const toast = useToast()

    return {
      toast,
    }
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
